import styled from 'styled-components';
import colors from '../../styles/colors';

export const EditWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 10px 0 20px 0;
  padding-right: 20px;
  box-sizing: border-box;
`;

export const EditContainer = styled.div`
  width: 100%;
  max-width: 650px;
  background: #ffffff;
  border: 1.5px solid ${colors.brand_600};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
`;

export const EditorBody = styled.div`
  max-height: 280px;
  overflow-y: auto;
  padding: 8px 12px;

  .tiptap-editor-input {
    min-height: 50px;
    outline: none;
    font-size: 14px;
    line-height: 1.5;
    color: #1f2937;
  }
`;

export const AttachmentSection = styled.div`
  padding: 8px 12px;
  border-top: 1px solid #ebeef5;
  background: #fafafa;

  p {
    margin: 0 0 6px 0;
    font-size: 12px;
    font-weight: 600;
    color: #4b5563;
  }

  .items-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const ExistingBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  color: #374151;
  max-width: 220px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    color: #9ca3af;
    margin-left: 4px;
    padding: 0;

    &:hover {
      color: #ef4444;
    }
  }
`;

export const NewFileCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  padding: 6px 26px 6px 8px;
  border-radius: 6px;
  width: 210px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  .preview-box {
    width: 38px;
    height: 38px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eff6ff;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    svg {
      color: ${colors.brand_600};
      font-size: 22px;
    }
  }

  .file-meta {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;

    .title {
      font-size: 12px;
      font-weight: 600;
      color: #1f2937;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subtitle {
      font-size: 10px;
      color: #6b7280;
      margin-top: 2px;
    }
  }

  .remove-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #9ca3af;
    padding: 2px;
    display: flex;

    &:hover {
      color: #ef4444;
    }
    svg {
      font-size: 14px;
    }
  }
`;

export const BottomToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 6px 12px;
  border-top: 1px solid #ebeef5;
  background: #ffffff;
  border-radius: 0 0 7px 7px;
`;

export const FloatingEmojiPicker = styled.div`
  position: absolute;
  right: 10px;
  ${({ $placement }) =>
    $placement === 'bottom'
      ? `
    top: calc(100% + 6px);
  `
      : `
    bottom: 46px;
  `}
  z-index: 9999;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  border: 1px solid #e5e7eb;
  overflow: hidden;
`;
